let ContactData = {
  Email_Address: "Email Address",
  Phone_No: "Mobile No",
  First_Name: "First Name",
  Last_Name: "Last Name",
  Marital_Status: "Marital Status",
  Gender: "Gender",
  City: "City",
  State: "State",
};

export const GenderData = [
  {
    1: "Male",
  },
  {
    2: "Female",
  },
  {
    4: "Other",
    Priorityy: 3,
  },
];

let ContactData_Nepal = {
  Email_Address: "Email Address",
  Phone_No: "Mobile No",
  First_Name: "First Name",
  Last_Name: "Last Name",
};

export const ContactCreateValidator1 = (data) => {
  for (let key in ContactData) {
    const Value = data[key].toString().trim();
    if (Value === "" || Value === undefined || Value === null) {
      return `Error - ${ContactData[key]} is required !`;
    }
  }

  return "success";
};

export const GET_DATE = (time) => {
  var today = new Date(time);
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedToday = yyyy + "-" + mm + "-" + dd;
  return formattedToday;
};

export const ContactCreateValidator1_Nepal = (data) => {
  for (let key in ContactData_Nepal) {
    const Value = data[key].toString().trim();
    if (Value === "" || Value === undefined || Value === null) {
      return `Error - ${ContactData_Nepal[key]} is required !`;
    } else if (
      key === "Email_Address" &&
      (!Value.includes(".") || !Value.includes("@"))
    ) {
      return "Error - please provide a valid email address !";
    }
  }

  return "success";
};

export const CountryListJson = [
  // {
  //   Id: 7,
  //   Country: "AFGHANISTAN",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-06-24T07:54:07.787Z",
  //   Priority: 6,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 12,
  //   Country: "ARGENTINA",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:06:03.123Z",
  //   Priority: 11,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  {
    Id: 4,
    Country: "AUSTRALIA",
    Active_Flag: 1,
    Created_By: 2,
    Created_Datetime: "2020-06-24T07:53:45.893Z",
    Priority: 3,
    Country_Symbol: "AU$",
    selected: "1",
    ImageC: "flags/australia_c.png",
    ImageC25: "flags/australia_c_25.png",
    ImageS: "flags/australia_s.png",
    ImageS25: "flags/australia_s_25.png",
  },
  {
    Id: 11,
    Country: "UK",
    Active_Flag: 1,
    Created_By: 2,
    Created_Datetime: "2020-07-31T04:20:31.910Z",
    Priority: 10,
    Country_Symbol: "£",
    selected: "1",
    ImageC: "flags/uk_c.png",
    ImageC25: "flags/uk_c_25.png",
    ImageS: "flags/uk_s.png",
    ImageS25: "flags/uk_s_25.png",
  },
  {
    Id: 32,
    Country: "USA",
    Active_Flag: 1,
    Created_By: 2,
    Created_Datetime: "2020-07-31T14:08:10.270Z",
    Priority: 31,
    Country_Symbol: "$",
    selected: "1",
    ImageC: "flags/usa_c.png",
    ImageC25: "flags/usa_c_25.png",
    ImageS: "flags/usa_s.png",
    ImageS25: "flags/usa_s_25.png",
  },
  {
    Id: 34,
    Country: "DUBAI",
    Active_Flag: 1,
    Created_By: 2,
    Created_Datetime: "2021-12-17T09:18:37.463Z",
    Priority: 33,
    Country_Symbol: "AED",
    selected: "1",
    ImageC: "flags/uae_c.png",
    ImageC25: "flags/uae_c_25.png",
    ImageS: "flags/uae_s.png",
    ImageS25: "flags/uae_s_25.png",
  },
  {
    Id: 9,
    Country: "CANADA",
    Active_Flag: 1,
    Created_By: 2,
    Created_Datetime: "2020-07-31T04:19:57.337Z",
    Priority: 8,
    Country_Symbol: "C$",
    selected: "1",
    ImageC: "flags/canada_c.png",
    ImageC25: "flags/canada_c_25.png",
    ImageS: "flags/canada_s.png",
    ImageS25: "flags/canada_s_25.png",
  },
  {
    Id: 25,
    Country: "OTHER",
    Active_Flag: 1,
    Created_By: 2,
    Created_Datetime: "2020-07-31T14:07:28.333Z",
    Priority: 24,
    Country_Symbol: null,
    selected: "0",
    ImageC: null,
    ImageC25: null,
    ImageS: null,
    ImageS25: null,
  },
  // {
  //   Id: 8,
  //   Country: "BANGLADESH",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-06-24T07:54:13.030Z",
  //   Priority: 7,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 13,
  //   Country: "BRAZIL",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:06:08.793Z",
  //   Priority: 12,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 14,
  //   Country: "CAMEROON",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:06:16.323Z",
  //   Priority: 13,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },

  // {
  //   Id: 5,
  //   Country: "CHILE",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-06-24T07:53:49.690Z",
  //   Priority: 4,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 6,
  //   Country: "CHINA",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-06-24T07:53:53.750Z",
  //   Priority: 5,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 15,
  //   Country: "COLOMBIA",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:06:24.177Z",
  //   Priority: 14,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 37,
  //   Country: "Denmark",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2022-11-28T06:03:51.880Z",
  //   Priority: 36,
  //   Country_Symbol: null,
  //   selected: null,
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },

  // {
  //   Id: 16,
  //   Country: "FIJI",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:06:30.280Z",
  //   Priority: 15,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 17,
  //   Country: "France",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:06:37.310Z",
  //   Priority: 16,
  //   Country_Symbol: "€",
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 10,
  //   Country: "GERMANY",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T04:20:13.780Z",
  //   Priority: 9,
  //   Country_Symbol: "€",
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 2,
  //   Country: "INDIA",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-06-24T07:53:37.990Z",
  //   Priority: 1,
  //   Country_Symbol: "₹",
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 18,
  //   Country: "IRAN",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:06:43.440Z",
  //   Priority: 17,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 19,
  //   Country: "IRELAND",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:06:49.690Z",
  //   Priority: 18,
  //   Country_Symbol: "£",
  //   selected: "1",
  //   ImageC: "flags/ireland_c.png",
  //   ImageC25: "flags/ireland_c_25.png",
  //   ImageS: "flags/ireland_s.png",
  //   ImageS25: "flags/ireland_s_25.png",
  // },
  // {
  //   Id: 42,
  //   Country: "Italy",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2024-11-27T06:21:58.273Z",
  //   Priority: 1,
  //   Country_Symbol: null,
  //   selected: null,
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 20,
  //   Country: "JAPAN",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:06:55.670Z",
  //   Priority: 19,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 21,
  //   Country: "KENYA",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:07:03.187Z",
  //   Priority: 20,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 22,
  //   Country: "LEBANON",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:07:09.230Z",
  //   Priority: 21,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 23,
  //   Country: "MALAYSIA",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:07:14.547Z",
  //   Priority: 22,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 41,
  //   Country: "MALTA",
  //   Active_Flag: 1,
  //   Created_By: 1,
  //   Created_Datetime: "2024-10-03T10:51:00.673Z",
  //   Priority: 1,
  //   Country_Symbol: "£",
  //   selected: null,
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 3,
  //   Country: "NEPAL",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-06-24T07:53:40.857Z",
  //   Priority: 2,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 24,
  //   Country: "NETHERLANDS",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:07:22.380Z",
  //   Priority: 23,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 35,
  //   Country: "NEW ZEALAND",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2021-12-17T09:19:37.610Z",
  //   Priority: 34,
  //   Country_Symbol: "NZ$",
  //   selected: "1",
  //   ImageC: "flags/nz_c.png",
  //   ImageC25: "flags/nz_c_25.png",
  //   ImageS: "flags/nz_s.png",
  //   ImageS25: "flags/nz_s_25.png",
  // },
  // {
  //   Id: 36,
  //   Country: "NORTHERN IRELAND",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2021-12-17T09:21:27.350Z",
  //   Priority: 35,
  //   Country_Symbol: "£",
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },

  // {
  //   Id: 26,
  //   Country: "PAKISTAN",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:07:34.717Z",
  //   Priority: 25,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 27,
  //   Country: "PHILLIPPINES",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:07:40.693Z",
  //   Priority: 26,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 40,
  //   Country: "SINGAPORE",
  //   Active_Flag: 1,
  //   Created_By: 1,
  //   Created_Datetime: "2024-10-03T10:50:47.990Z",
  //   Priority: 1,
  //   Country_Symbol: "S$",
  //   selected: null,
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 28,
  //   Country: "SLOVAKIA",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:07:47.153Z",
  //   Priority: 27,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 29,
  //   Country: "SOUTH AFRICA",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:07:52.450Z",
  //   Priority: 28,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 39,
  //   Country: "SPAIN",
  //   Active_Flag: 1,
  //   Created_By: 1,
  //   Created_Datetime: "2024-09-27T11:26:11.547Z",
  //   Priority: 1,
  //   Country_Symbol: "€",
  //   selected: null,
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 30,
  //   Country: "SRI LANKA",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:07:58.677Z",
  //   Priority: 29,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 38,
  //   Country: "SWITZERLAND",
  //   Active_Flag: 1,
  //   Created_By: 1,
  //   Created_Datetime: "2024-09-27T11:00:53.470Z",
  //   Priority: 1,
  //   Country_Symbol: "CHF",
  //   selected: null,
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
  // {
  //   Id: 31,
  //   Country: "THAILAND",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:08:04.770Z",
  //   Priority: 30,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },

  // {
  //   Id: 33,
  //   Country: "VIETNAM",
  //   Active_Flag: 1,
  //   Created_By: 2,
  //   Created_Datetime: "2020-07-31T14:08:16.963Z",
  //   Priority: 32,
  //   Country_Symbol: null,
  //   selected: "0",
  //   ImageC: null,
  //   ImageC25: null,
  //   ImageS: null,
  //   ImageS25: null,
  // },
];

export const sectionStyle = `
  background-color: #a4a3a2;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 18px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  color: black;
`;

export const DisplayNone = `
 display:none;
`;

export const containerStyle = `
  max-width: 900px;
  margin: auto;
  padding: 20px;
  font-family: "Poppins", sans-serif;
`;

export const tableStyle = `
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  margin-bottom: 20px;
`;

export const thTdStyle2 = `
  width: 50%;
  padding: 8px 12px;
  border-bottom: 1px solid #ddd;
  background-color: #fff;
  font-size: 17px;
`;

export const thTdStyle = `
  width: 40%;
  padding: 8px 12px;
  border-bottom: 1px solid #ddd;
  background-color: #fff;
  font-size: 14px;
  color: #f26524;
  font-weight: 700;
`;

export const clr = `
  color: #f26524;
  font-weight: 700;
`;

export const gridClr = `
   display: grid;
  grid-template-columns: repeat(2, 1fr); 
  gap: 10px;
  color: #f26524;
  font-weight: 700; `;

export const thTdStyle1 = `
  width: 40%;
  padding: 8px 12px;
  border-bottom: 1px solid #ddd;
  background-color: #fff;
  font-size: 17px;
`;

export const thTdStyle3 = `
  width: 100%;
  padding: 8px 12px;
  border-bottom: 1px solid #ddd;
  background-color: #fff;
  font-size: 17px;
`;
